import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import DictsInfo from '../../components/dicts_info.jsx'
// import GambarPointer1 from './img/pointer1.png'


export default class CaraMengteditSheetMsOfficeExcel2010 extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Cara Mengedit Sheet Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Cara Mengedit Sheet Pada Microsoft Office Excel 2010</h1>

                <p>Kita dapat mengedit sheet pada dokumen kita misalnya menghapus, mengcopy, memindah mengubah nama ataupun mengganti warna tab.</p>

                <p>Simak baik baik caranya di bawah ini.</p>
                
                <div className= "w3-container" > 
                    <ol> 
                        <li>Cara memindahkan sheet microsoft office excel 2010</li> 
                        <div className= "w3-container" > 
                            <ol> 
                                <li>Klik nama tab sheet yang akan dipindahkan. Misal pada tab sheet1, kita akan memindahkan diantara sheet4 dan sheet5.</li> 
                                <li>Draging ke kanan sesuai posisi yang di inginkan, lalu lepas mouse. Baca tutorial draging bila belum paham cara draging.</li>                                  
                            </ol> 
                        </div>
                        <br/>

                        <li>Cara mengubah nama tab pada sheet microsoft office excel 2010</li>
                        <div className= "w3-container" > 
                            <ol> 
                                <li>Pilih nama sheet yang akan diubah namanya</li>
                                <li>Klik kanan lalu pilih rename</li>
                                <li>rubah nama menjadi nama sesuai keinginan</li>
                                <li>Lalu Tekan enter</li>
                                <li>Selain cara tersebut dapat juga dengan cara double klik pada nama sheet</li>
                                <li>rubah nama menjadi nama sesuai keinginan</li>
                                <li>Lalu tekan enter</li>
                            </ol> 
                        </div>
                        <br/>

                        <li>Cara meng copy sheet microsoft office excel 2010</li>
                        <div className= "w3-container" > 
                            <ol> 
                                <li>Pilih atau klik nama sheet yang akan di copy</li> 
                                <li>Tekan dan tahan tombol Ctrl</li> 
                                <li>Drag kekiri atau kekanan</li> 
                                <li>Lepas mouse dan tombol Ctrl</li>
                                <li>Nama sheet biasanya akan menjadi nama duplikasi. Misal <b>Sheet1</b> akan menjadi <b>Sheet1 (2)</b></li>
                                <li>Rubah nama jika di inginkan</li>
                            </ol> 
                        </div>
                        <br/>

                        <li>Cara mengubah warna tab pada microsoft office excel 2010</li>
                        <div className= "w3-container"> 
                            <ol>
                                <li>Pilih nama sheet yang akan diubah warnanya</li>
                                <li>Klik kanan lalu pilih <b>Tab Color</b></li>
                                <li>Lalu pilih warna sesuai keinginan</li>                               
                            </ol> 
                        </div>
                        <br/>

                        <li>Cara menyembunyikan dan menampilkan kembali sheet pada microsoft office excel 2010</li>
                        <div className= "w3-container" > 
                            <ol> 
                                <li>Klik nama sheet yang akan disembunyikan</li> 
                                <li>Lalu klik kanan dan pilih <b>Hide</b>. Maka sheet akan tidak terlihat.</li> 
                                <li>Dan untuk menampilkan kembali, klik salah satu nama sheet dalam tab.</li>
                                <li>Kemudian klik kanan dan klik pilihan <b>Unhide</b>. Kemudian kotak dialog akan muncul, sheet mana saja yg telah ter hide.</li>
                                <li>Klik pada nama sheet, lalu ok</li>
                                <li></li>
                            </ol> 
                        </div>
                        <br/>

                        <li>Cara menambah sheet pada microsoft office excel 2010
                        <br/>
                        Apabila sheet dalam dokument telah habis, dan kita masih ingin menambahkan dokumen. Kita dapat melakukannya dengan cara berikut.</li>
                        <div className= "w3-container" > 
                            <ol> 
                                <li>Klik pada salah satu sheet</li> 
                                <li>Lalu klik kanan dan pilih insert, lalu kotak dialog akan muncul</li> 
                                <li>Klik pilihan pada worksheet lalu klik OK</li> 
                                <li>Maka sheet baru pun akan terbuat</li>                                  
                            </ol> 
                        </div>
                        <br/>

                        <li>Cara menghapus sheet pada microsoft office excel 2010</li>
                        <div className= "w3-container" > 
                            <ol> 
                                <li>Klik pada salah satu sheet yang ingin dihapus</li> 
                                <li>Klik kanan lalu pilih <b>Delete</b></li> 
                                <li>Maka sheet akan langsung terhapus</li>
                            </ol> 
                        </div>
                    </ol> 
                </div>
                <br/>

                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
